import injectSheet from 'react-jss'
import Table from './Table'
import styles from './Table.styles'

export default injectSheet(styles)(Table)
